module.exports = __webpack_public_path__ + "media/images/banks/ocbc-432cfa1a5facf79e4903cba604f29879.png";